<template>
    <div name="privacy-settings">
        <div class="ui two column stackable grid">
            <div class="eight wide column">
                <div class="ui segment">
                    <div class="ui header">Ny EU persondataforordning - GDPR</div>
					<p>
						Zietwing passer godt på dine oplysninger og overholder de nye EU regler for datahåndtering. Vi gemmer kun de data som er nødvendige for at kunne give dig en god brugeroplevelse.
						Eksempler på typer af data som gemmes i Zietwing:
						<ul>
							<li>Oplysninger du selv har gemt</li>
							<li>Krypteret betalingsidentitet</li>
							<li>Betalingshistorik</li>
						</ul>
					</p>
					<p>Derudover kan forhandleren du har et abonnement hos, vælge at gemme andre informationer som gør at forhandleren kan levere ydelsen til dig.</p>
					<p>Ifølge den nye persondata lov bestemmer du selv hvem du deler dine informationer med og hvad de bruges til. Zietwing giver dig mulighed for at udøve din ret til indsigt omkring hvilke oplysninger forhandleren gemmer om dig.</p>
					<p>Ønsker du ikke at beholde dine data i Zietwing kan du anmode om at blive glemt. Dine data vil så blive slettet/ anonymiseret i Zietwing og du vil ikke længere kunne modtage ydelsen fra dine forhandlere eller tilgå din brugerprofil.</p>
					<p> Læs i øvrigt Zietwings <a @click.prevent="openTerms()">handelsbetingelser, cookies- og privatlivspolitikker</a> hvis du gerne vil vide mere omkring hvordan vi løbende arbejder på at sikre dine informationer.</p>

                </div>
            </div>
            <div class="eight wide column">
                <div class="ui form">
					<div class="field">
                        <div class="ui red button" @click="showUserdataNotice = !showUserdataNotice">
							{{ $t('pages.profile.settings.privacy.userdata.button') }}
						</div>
                    </div>
                    <div class="ui segment">
						<b>{{ $t('pages.profile.settings.privacy.userdata.header') }}</b>
                        <p>
							{{ $t('pages.profile.settings.privacy.userdata.body') }}
						</p>
                    </div>
                    <div class="field">
                        <div class="ui red button" @click="showForgottenNotice = !showForgottenNotice">
							{{ $t('pages.profile.settings.privacy.forgotten.button') }}
						</div>
                    </div>
                    <div class="ui segment">
						<b>{{ $t('pages.profile.settings.privacy.forgotten.header') }}</b>
                        <p>
							{{ $t('pages.profile.settings.privacy.forgotten.body') }}
						</p>
                    </div>
                </div>
            </div>
        </div>

		<modal ref="forgottenmodal" :active="showForgottenNotice" :title="$t('pages.profile.settings.privacy.forgotten.modal.title')" :icons="'big times circle outline'" @acceptmodal="requestForgotten()">
			<h3>{{ $t('pages.profile.settings.privacy.forgotten.modal.header') }}</h3>
      <span v-html="$t('pages.profile.settings.privacy.forgotten.modal.body')"/>

			<div slot="box-actions">
				<div class="ui basic circular red button" @click="$refs.forgottenmodal.denyModal()">{{ $t('globals.buttons.cancel') }}</div>
				<div class="ui blue circular button" @click="$refs.forgottenmodal.acceptModal()">{{ $t('globals.buttons.accept') }}</div>
			</div>
		</modal>

		<modal ref="userdatamodal" :active="showUserdataNotice" :title="$t('pages.profile.settings.privacy.userdata.modal.title')" :icons="'big user circle'" @acceptmodal="requestUserData()">
			<h3>{{ $t('pages.profile.settings.privacy.userdata.modal.header') }}</h3>
      <span v-html="$t('pages.profile.settings.privacy.userdata.modal.body')"/>

			<div slot="box-actions">
				<div class="ui basic circular red button" @click="$refs.userdatamodal.denyModal()">{{ $t('globals.buttons.cancel') }}</div>
				<div class="ui blue circular button" @click="$refs.userdatamodal.acceptModal()">{{ $t('globals.buttons.accept') }}</div>
			</div>
		</modal>
    </div>
</template>


<script>
	export default {
		name: 'PrivacySettings',

		data () {
			return {
				showForgottenNotice: false,
				showUserdataNotice: false
			}
		},

		methods: {
			requestUserData () {
				// PUT:  {API_URL}/users/export
				return new Promise((resolve, reject) => {
					this.axios.put(`users/export`)
						.then(({data}) => {
							if (data.success === true) {
								this.$events.$emit('alert', {
									header: this.$t('pages.profile.settings.privacy.forgotten.validation.success.request_received'),
									message: this.$t('pages.profile.settings.privacy.forgotten.validation.success.receive_message'),
									type: 'success',
									align: 'right'
								})

								resolve(data)
							}
						})
						.catch(error => {
							this.$events.$emit('alert', {
								header: this.$t('globals.validation.errors.something_went_wrong'),
								message: this.$t('globals.validation.errors.try_again_later'),
								type: 'error',
								align: 'right'
							})

							reject(error)
						})
				})
			},

			requestForgotten () {
				return new Promise((resolve, reject) => {
					this.axios.delete(`/users`)
						.then(({data}) => {
							if (data.success === true) {
								this.$events.$emit('alert', {
									header: this.$t('pages.profile.settings.privacy.forgotten.validation.success.request_received'),
									message: this.$t('pages.profile.settings.privacy.forgotten.validation.success.receive_message'),
									type: 'success',
									align: 'right'
								})

								resolve(data)
							}
						}).catch(error => {
							this.$events.$emit('alert', {
								header: this.$t('globals.validation.errors.something_went_wrong'),
								message: this.$t('globals.validation.errors.try_again_later'),
								type: 'error',
								align: 'right'
							})

							reject(error)
						})
				})
			},

			openTerms () {
				this.$events.$emit('openTerms')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/pages/profile/PrivacySettings.vue